import { FeatureFlag } from '../FeatureFlag';

export const enableOrderDebugFirmFilter = new FeatureFlag({
    key: 'enable-order-debug-firm-filter',
    createdOn: '2025-05-27',
    defaultValue: false,
});
